<template>
    <el-dialog class="dialog dialog-mini" :visible="dialogs.help" customClass="dialog_main dialog-mini_main" :append-to-body="true" :close-on-click-modal="false" @close="closeDialog()">
        <div slot="title" class="dialog__head dialog__head_second">
            <div class="dialog__head-inner">
                <h3 class="dialog__title">Помощь и запрос</h3>
            </div>
        </div>

        <div slot="default" class="dialog__inner">
            <form
                action="#"
                class="dialog__form"
                @submit.prevent="submitForm"
                autocomplete="off"
            >
                <div class="dialog__content">
                    <validate-input type="email" name="email" placeholder="Ваша электронная почта" v-model="email" v-bind:error="emailError" v-on:update:error="emailError = $event" :validateOptions="['empty', 'email']"/>

                    <validate-input class="mt-8" type="text" name="name" placeholder="Ваше имя" v-model="name" v-bind:error="nameError" v-on:update:error="nameError = $event" :validateOptions="['empty']"/>

                    <textarea name="comment" class="textarea textarea_10rem mt-8" placeholder="Комментарий" v-model="comment" />
                </div>

                <footer slot="footer" class="dialog__footer mt-24">
                    <div class="dialog__footer-inner">
                        <div class="dialog__footer-item ml-auto">
                            <button type="submit" class="btn btn_action" :disabled="!email.length || !name.length || !comment.length || emailError || nameError">
                                Отправить
                            </button>
                        </div>
                    </div>
                </footer>
            </form>
        </div>
    </el-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

import constants from '@/constants.js';
import dialog from '@/mixins/dialog';
import ValidateInput from '@/components/ValidateInput';

export default {
    mixins: [ dialog ],
    components: {
        ValidateInput
    },
    data() {
        return {
            email: '',
            name: '',
            comment: '',
            emailError: false,
            nameError: false,
        }
    },
    methods: {
        ...mapActions('common', ['SEND_HELP_EMAIL']),
        ...mapMutations('common', ['TOGGLE_ALERT']),
        closeDialog() {
            this.elDialogs.help = false;
        },
        async submitForm() {
            await this.SEND_HELP_EMAIL({name: this.name, email: this.email, comment: this.comment});
            this.closeDialog();
            this.email = '';
            this.name = '';
            this.comment = '';
        }
    },
    computed: {
    },
    mounted() {
    }
}
</script>
